import { render } from "./MypageHeader.vue?vue&type=template&id=6cde6bda"
import script from "./MypageHeader.vue?vue&type=script&lang=js"
export * from "./MypageHeader.vue?vue&type=script&lang=js"

import "./MypageHeader.vue?vue&type=style&index=0&id=6cde6bda&lang=css"

import exportComponent from "/Users/learnbody/Documents/VSWorkspaces/learnbody-market-v1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__